import React, { useState } from 'react';
import { projectService } from '../api/services';

export default function ListingProjectImport({ onSelect, onProject, onClear }) {
  const [code, setCode] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selected, setSelected] = useState('');
  const lookup = async () => {
    setLoading(true); setError(''); setResult(null); setSelected('');
    try { const data = await projectService.lookup(code.trim()); setResult(data); onProject?.(data.project); }
    catch { setError('Không tìm thấy dự án hoặc bạn không có quyền sử dụng dự án này.'); }
    finally { setLoading(false); }
  };
  return <div className="form-group">
    <div className="listing-project-fields">
    <div>
    <label className="form-label" htmlFor="listing-project-code">Mã dự án (không bắt buộc)</label>
    <div className="listing-project-lookup">
      <input id="listing-project-code" className="form-input" value={code} disabled={loading} maxLength={25} placeholder="LIST-…" onChange={(event) => { setCode(event.target.value.toUpperCase()); setResult(null); setSelected(''); setError(''); onClear?.(); }} onKeyDown={(event) => { if (event.key === 'Enter') { event.preventDefault(); if (code.trim() && !loading) lookup(); } }} />
      <button type="button" className="btn btn-neutral" disabled={loading || !code.trim()} onClick={lookup}>{loading ? 'Đang tìm…' : 'Tìm dự án'}</button>
    </div>
    </div>
    {result && <div>
      <label className="form-label" htmlFor="listing-project-room">Chọn phòng trong dự án</label>
      <select id="listing-project-room" className="form-select" value={selected} onChange={(event) => { setSelected(event.target.value); const room = result.rooms.find((item) => String(item.id) === event.target.value); if (room) onSelect(result.project, room); else onClear?.(); }}>
        <option value="">{result.rooms.length ? 'Chọn mã phòng' : 'Dự án chưa có phòng'}</option>
        {result.rooms.map((room) => <option key={room.id} value={room.id}>{room.details?.roomCode || room.title}{room.status === 'rented' ? ' · Đã cho thuê' : room.status === 'maintenance' ? ' · Bảo trì' : ''}</option>)}
      </select>
    </div>}
    </div>
    {error && <small role="alert" className="error-message">{error}</small>}
    {result && <>
      <small>{result.project.name}</small>
      <small>Thông tin được sao chép sang tin đăng riêng. Bạn có thể chỉnh lại trước khi đăng.</small>
    </>}
  </div>;
}
